import { Slider, SliderProps } from '@makyoapp/makyo-tw-ui'

export type CompSliderProps = SliderProps

export const CompSliderCore = Slider
